/* Locale-safe prices and newest recommendations. Does not calculate cart totals. */
(() => {
  'use strict';
  if (window.KathwoolCommerce) return;
  const language = () => document.documentElement.lang || 'en';
  const locale = language().toLowerCase().split('-')[0];
  const labels = {
    fr: { pdf: 'Téléchargement PDF numérique', view: 'Voir le modèle', all: 'Voir tous les modèles', offer: '15 % de réduction à la caisse' },
    de: { pdf: 'Digitaler PDF-Download', view: 'Anleitung ansehen', all: 'Alle Anleitungen ansehen', offer: '15 % Rabatt an der Kasse' },
    en: { pdf: 'PDF Digital download', view: 'View pattern', all: 'View all patterns', offer: '15% off at checkout' },
  }[locale] || { pdf: 'PDF Digital download', view: 'View pattern', all: 'View all patterns', offer: '15% off at checkout' };

  const money = (cents, currency = 'USD') => {
    const options = new Intl.NumberFormat(language(), { style: 'currency', currency }).resolvedOptions();
    const amount = new Intl.NumberFormat(language(), {
      minimumFractionDigits: options.minimumFractionDigits,
      maximumFractionDigits: options.maximumFractionDigits,
    }).format(Number(cents) / 100);
    return (currency === 'USD' ? '$' : '') + amount;
  };
  const rootPath = window.Shopify?.routes?.root || (['fr', 'de'].includes(locale) ? `/${locale}/` : '/');
  const collectionPath = `${rootPath}collections/all`;
  let newestRequest;

  const newest = () => {
    if (newestRequest) return newestRequest;
    const url = new URL(collectionPath, window.location.origin);
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('section_id', 'kw-newest-recommendations');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    newestRequest = fetch(url, { credentials: 'same-origin', signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error('Newest recommendations could not be loaded.');
        return response.text();
      })
      .then(html => {
        const payload = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('[data-kw-newest-payload]');
        if (!payload) throw new Error('Recommendation data is unavailable.');
        const data = JSON.parse(payload.textContent);
        const seen = new Set();
        data.products = (data.products || []).filter(product => {
          if (!product.id || seen.has(String(product.id)) || !product.url || !product.image) return false;
          if (new URL(product.url, location.origin).origin !== location.origin) return false;
          const localizedURL = new URL(product.url, location.origin);
          if (rootPath !== '/' && localizedURL.pathname.startsWith('/products/')) {
            localizedURL.pathname = rootPath + localizedURL.pathname.slice(1);
          }
          product.url = localizedURL.pathname + localizedURL.search + localizedURL.hash;
          seen.add(String(product.id));
          return true;
        }).sort((a, b) => Number(b.createdAt) - Number(a.createdAt));
        if (!data.products.length) throw new Error('No eligible patterns were returned.');
        return data;
      }).finally(() => clearTimeout(timeout));
    return newestRequest;
  };

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const link = (className, url, text) => {
    const node = el('a', className, text);
    node.href = url;
    return node;
  };
  const title = product => String(product.title)
    .split(/\s[—–]\s(?:Patron|Modèle|Häkel|Crochet|PDF|Digital)/i)[0]
    .split(/\s(?:C2C\s+)?Crochet\b|\s*\|/i)[0];
  const image = product => {
    const node = el('img');
    node.src = product.image;
    node.alt = product.title;
    node.width = Number(product.width) || 900;
    node.height = Number(product.height) || 1200;
    node.loading = 'lazy';
    node.decoding = 'async';
    return node;
  };
  const prices = (product, data, className, tag = 'span') => {
    const active = Date.now() < Date.parse(data.offerEnds);
    const current = active ? Math.round(Number(product.price) * .85) : Number(product.price);
    const original = active ? Number(product.price) : Number(product.compare);
    const node = el(tag, className);
    node.setAttribute('data-kw-localization-ignore', '');
    node.append(el('b', '', money(current, data.currency)));
    if (original > current) node.append(el('s', '', money(original, data.currency)));
    node.append(el('small', '', data.currency));
    return node;
  };
  const pdpCard = (product, data) => {
    const node = link('kwp-pc', product.url);
    const media = el('div', 'kwp-5'); media.append(image(product));
    node.append(media, el('p', 'kwp-card-format', labels.pdf), el('h3', '', title(product)), prices(product, data, 'kwp-cpr'));
    if (Date.now() < Date.parse(data.offerEnds)) {
      node.append(el('p', 'kwp-card-offer', labels.offer));
    }
    return node;
  };
  const wallCard = product => {
    const node = link('kwp-35', product.url);
    node.setAttribute('aria-label', product.title);
    node.append(image(product), el('span', '', title(product)));
    return node;
  };
  const viewAll = () => {
    const node = link('kwp-34', collectionPath);
    const plus = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [key, value] of Object.entries({ viewBox: '0 0 24 24', width: '32', height: '32', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'aria-hidden': 'true' })) plus.setAttribute(key, value);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M12 5v14M5 12h14'); plus.append(path);
    node.append(plus, el('span', '', labels.all));
    return node;
  };
  const cartCard = (product, data) => {
    const node = el('article', 'kw-cart-pattern');
    const media = link('kw-cart-pattern-image', product.url); media.append(image(product));
    const heading = el('h3'); heading.append(link('', product.url, title(product)));
    const bottom = el('div', 'kw-cart-pattern-bottom');
    const priceGroup = el('div', 'kw-cart-price-group');
    priceGroup.append(prices(product, data, 'kw-compact-price', 'p'));
    if (Date.now() < Date.parse(data.offerEnds)) {
      priceGroup.append(el('p', 'kw-cart-offer', labels.offer));
    }
    bottom.append(priceGroup, link('kw-cart-text-link', product.url, `${labels.view} ↗`));
    node.append(media, el('p', 'kw-cart-pattern-label', labels.pdf), heading, bottom);
    return node;
  };
  const journalCard = (product, data) => {
    const node = el('article', 'product');
    const media = link('product-image', product.url); media.append(image(product));
    const heading = el('h3'); heading.append(link('', product.url, title(product)));
    const bottom = el('div', 'product-bottom');
    const price = prices(product, data, 'price', 'p');
    // The journal's existing CSS targets a span for its single currency code.
    const currency = price.querySelector('small');
    const code = el('span', '', currency.textContent); currency.replaceWith(code);
    const more = link('plus', product.url, '+'); more.setAttribute('aria-label', `${labels.view}: ${title(product)}`);
    bottom.append(price, more);
    node.append(media, el('p', 'format', labels.pdf), heading, bottom);
    return node;
  };

  const refresh = async () => {
    const grids = [...document.querySelectorAll('[data-kw-newest-grid]')]
      .filter(grid => !grid.dataset.kwNewestReady);
    if (!grids.length) return;
    let data;
    try { data = await newest(); }
    catch (error) {
      // Keep usable server-rendered cards rather than clearing a whole section.
      grids.forEach(grid => { grid.dataset.kwNewestError = 'unavailable'; });
      console.warn('[Kathwool recommendations]', error.message);
      return;
    }
    for (const grid of grids) {
      if (!grid.isConnected) continue;
      const productRoot = grid.closest('[data-kwp-fresh]');
      const excluded = new Set((grid.dataset.kwExcludeProducts || '').split(',').filter(Boolean));
      if (productRoot?.dataset.kwProductId) excluded.add(productRoot.dataset.kwProductId);
      const available = data.products.filter(product => !excluded.has(String(product.id)));
      const kind = grid.dataset.kwNewestGrid;
      let nodes;
      if (kind === 'pdp') nodes = available.slice(0, 15).map(product => pdpCard(product, data));
      else if (kind === 'wall') nodes = [...available.slice(15, 26).map(wallCard), viewAll()];
      else if (kind === 'cart') nodes = available.slice(0, 4).map(product => cartCard(product, data));
      else if (kind === 'journal') nodes = available.slice(0, 4).map(product => journalCard(product, data));
      if (!nodes?.length) continue;
      grid.replaceChildren(...nodes);
      grid.dataset.kwNewestReady = 'true';
      grid.dataset.kwNewestOrder = 'created-descending';
    }
  };
  window.KathwoolCommerce = { money, newest, refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();


